import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../authentication.service';
import { LoadingDirective } from '@styleguide/loading/loading.directive';

@Component({
  templateUrl: 'logout.component.html',
  styleUrls: ['logout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [LoadingDirective],
})
export class LogoutComponent implements OnInit {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.authenticationService.logout().subscribe(() => {
      this.router.navigate(['/']);
    });
  }
}
